import type Lenis from "lenis";

let lenis: Lenis | null = null;

/** The active smooth-scroll instance, or null when reduced motion is on. */
export const getLenis = () => lenis;

export const setLenis = (instance: Lenis | null) => {
  lenis = instance;
};
